import React, { useState } from "react";
import { ChevronDown } from "react-feather";
import { CustomLink } from "src/components/Common/CustomLink";
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from "reactstrap";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const ProfileDropdown = ({ username, menuItems, avatar, tag = "div" }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const renderAvatar = () => {
    if (avatar) {
      return <img src={avatar} alt="avatar" className="rounded-circle shadow-4-strong" />;
    }
    return <span className="avatar-xsm user-avatar shadow-4-strong bg-skin-user">{username?.charAt(0).toUpperCase()}</span>;
  };

  const renderMenuItem = (item, index) => {
    const Icon = item.icon;

    if (item.isText) {
      return (
        <div key={`${index}-profile-menu`} className="notify-item text-overflow m-l-3">
          <p className={`only-text p-l-24 p-r-24 active mb-0 ${item.customClassName || ""}`}>{item.label}</p>
          {item.doctorID && <span className="only-text p-l-24 p-r-24 mb-2 color-gray-900">{item.doctorID}</span>}
          <DropdownItem divider />
        </div>
      );
    }

    if (item.redirectTo) {
      return (
        <CustomLink
          key={`${index}-profile-menu`}
          to={item.redirectTo}
          className={`dropdown-item notify-item d-flex gap-1 align-items-center ${item.customClassName || ""}`}
          style={{ whiteSpace: "normal" }}
          onClick={item.action}
          role="presentation"
        >
          {Icon && <Icon className={`icon-dual no-fill icon-xs mr-2 ${item.iconClass}`} />}
          <span>{item.label}</span>
        </CustomLink>
      );
    }

    if (item.onClick) {
      return (
        <div
          key={`${index}-profile-menu`}
          role="button"
          className={`dropdown-item notify-item cursor-pointer d-flex gap-1 align-items-center ${item.customClassName || ""}`}
          onClick={item.onClick}
        >
          {Icon && <Icon className={`icon-dual no-fill icon-xs mr-2 ${item.iconClass}`} />}
          <span>{item.label}</span>
        </div>
      );
    }

    return null;
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="align-self-center profile-dropdown min-w170px" tag={tag}>
      <DropdownToggle
        data-toggle="dropdown"
        tag="a"
        className="nav-link dropdown-toggle nav-user mr-0"
        aria-expanded={dropdownOpen}
        role="button"
      >
        <div className="media user-profile cursor-pointer d-flex gap-1 justify-content-end">
          <div className="media-body text-left d-flex align-items-center">
            <h6 className="pro-user-name ml-2 my-0 d-flex gap-2 align-items-center">
              {renderAvatar()}
              <TooltipWrapper
                tooltipText={username}
                show={username?.length > 26}
                id="profile-name-tooltip"
                tooltipClassName="max-width-by-px-300"
              >
                <span className="d-block overflow-hidden text-truncate max-width-by-px-200">{username}</span>
              </TooltipWrapper>
            </h6>
          </div>
          <ChevronDown className="ml-2 align-self-center icon-dropdown-profile color-gray-600" size={18} />
        </div>
      </DropdownToggle>
      <DropdownMenu end className="topbar-dropdown-menu profile-dropdown-items">
        <div onClick={toggleDropdown}>
          {menuItems.map((item, index) => (
            <React.Fragment key={index}>
              {item.hasDivider && <DropdownItem divider />}
              {renderMenuItem(item, index)}
            </React.Fragment>
          ))}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
